// extracted by mini-css-extract-plugin
module.exports = {"instructions":"SelectType-module__instructions___3fSkG","cards":"SelectType-module__cards___zfrL2"};